// extracted by mini-css-extract-plugin
export default {"cls1":"NewUserDiscountButton-cls1__b_","cls2":"NewUserDiscountButton-cls2__vY NewUserDiscountButton-cls1__b_","blue":"NewUserDiscountButton-blue_kAk"};